import { useSettings } from '@wu/widget-core';
import { MOBILE_WIDTH, TABLET_WIDTH } from '../../constants';

export const useGutterResult = (width) => {
  const { gutter, gutterTablet, gutterMobile } = useSettings();

  if (width <= MOBILE_WIDTH) {
    return gutterMobile;
  }

  if (width <= TABLET_WIDTH) {
    return gutterTablet;
  }

  return gutter;
};
